export const environment = {
  ENVIRONMENT: "production",

  // Client version (bumping this version would force all clients to reset their local storage)
  CLIENT_VERSION: "20250701",

  // Variables
  NUM_SPACES: 500,
  NUM_CITIES: 70,
  NUM_MEMBERS: '10K',
  NUM_SUBSCRIBERS: '35,000',

  // API
  API: 'https://api.getcroissant.com',
  WWW: 'https://www.getcroissant.com',

  // Intercom
  INTERCOM_APP_ID: "y1cjauhb",

  // Facebook
  FACEBOOK_APP_ID: "1038924799482660",

  // GOOGLE MAP
  GOOGLE_MAP_API_KEY: "AIzaSyCeIwuBENBpuAvO-9YvGlbKw_qKwR4HjNk",
  GOOGLE_MAP_ID: "a3ab0124d5550dc3",

  // SENTRY
  SENTRY_DSN: "https://971f966d5816e41f31a0908ca3a58bc3@o393816.ingest.us.sentry.io/4509574019219456"

};
